module.exports = __webpack_public_path__ + "img/cloth_g1_item_18.13361b0c.svg";